import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { ReactComponent as LogoWOM } from '../../assets/images/logo-wom.svg';
import {
  Wrapper,
  ContainerStyled,
  CircleContainerStyled,
} from './styles/LoginLoaderStyled';
import useLogin from './hooks/useLogin';
import LoadingComponent from './LoadingComponent';
import useLogout from './hooks/useLogout';
import useUser from '../../hooks/useUser';
import AppLayout from './AppLayout';
import DarksideLayout from './DarksideLayout';

const AppManager = ({ location, children }) => {
  const user = useUser();
  const login = useLogin();
  const logout = useLogout();
  const [isDarkside, setIsDarkSide] = useState(false);

  useEffect(() => {
    const initLogin = async () => {
      const { status } = await login();
      switch (status) {
        case 200:
          if (location.pathname === '/') navigate('/home', { replace: true });
          break;
        case 401:
          logout();
          break;
        case 403:
          setIsDarkSide(true);
          navigate('/login/darkside', { replace: true });
          break;
        default:
          setIsDarkSide(true);
          navigate('/login/error-servidor', { replace: true });
          break;
      }
    };
    initLogin();
  }, []);

  if (isDarkside) return <DarksideLayout>{children}</DarksideLayout>;
  if (user && !isDarkside) return <AppLayout>{children}</AppLayout>;

  return (
    <Wrapper>
      <header>
        <LogoWOM />
      </header>
      <ContainerStyled>
        <CircleContainerStyled>
          <LoadingComponent />
        </CircleContainerStyled>
      </ContainerStyled>
    </Wrapper>
  );
};

AppManager.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.node.isRequired,
};

export default AppManager;
